export enum AbutmentTypeV1 {
	CustomAbutment = 1,
	StockAbutment = 2,
	StockAbutmentTiBased = 3,
	CustomAbutmentTiBased = 4,
}